import { Gavel, Print } from "@mui/icons-material";
import { FormControl, Grid, IconButton, Paper, TextField, Tooltip } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IEventListData } from "../../_common/interface/event/iEventListData";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../../_components/grid/styledGrid";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { API_URL } from "../../_config/config.const";
import { getDate } from "../../_helpers/dateTime.helper";
import { getMoneyFormat } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { reportService } from "../../_services/report.service";
import { tokenService } from "../../_services/token.service";
import { useContainerStyles } from "../../_styles/container.styles";


export function ReportIndex() {

    const [data, setData] = useState<IEventListData>({ items: [], count: 0 });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        name: '',
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'actions',
                header: 'Actions',
                Cell: ({ cell, table, row }) => (

                    <>
                        <Tooltip title="Print">
                            <IconButton onClick={e => { downloadReport(row.original.normalisedName); }}>
                                <Print color="success" />
                            </IconButton>
                        </Tooltip>
                    </>

                ),
                size: 1
            },
            {
                accessorKey: 'name',
                header: 'Name',
            },      
        ],
        [],
    );

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {

        return reportService.getAll({ ...filter })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function handleChange(event: any) {
        setFilter((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };


    function downloadReport(rowData: string) {
        tokenService.GetReportToken().then((data) => {
            window.location.href = API_URL + "/report/" + rowData + "/?token=" + data;
        });

    }

    return (
        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="Reports"
                />
                <Paper>

                    <ValidatorForm onSubmit={fetchData}>
                        <StyledGrid container spacing={2}>


                        </StyledGrid>
                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        filter={filter}
                        setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                        isLoading={isLoading}
                    />
                   

                </Paper>

            </div>
        </>

    );

}
